<div id="tour-trunk-header" class="flex align-items-center gap-2 mb-2">
  <h2>Trunking Summary</h2>
  <button
    pButton
    [text]="true"
    [rounded]="true"
    icon="pi pi-question-circle"
    pTooltip="Start tour"
    tooltipPosition="bottom"
    (click)="startTour()"
  ></button>
</div>

<app-domain-multiple-selector
  id="tour-trunk-domain-selector"
  [label]="'Select the domains to retrieve trunking summary information'"
  [buttonLabel]="'Get trunking summaries'"
  [panelCollapsed]="collapsed"
  [requesting]="requesting"
  [domains]="domainsList"
  (selectionChanged)="process($event)"
>
</app-domain-multiple-selector>

@if ( domainSummaries ) {
<div id="tour-trunk-results">
<div class="download-bar">
  <p-button
    icon="pi pi-download"
    [rounded]="true"
    [raised]="true"
    severity="info"
    size="large"
    pTooltip="Download trunking summary as CSV file"
    tooltipPosition="left"
    (onClick)="download()"
  ></p-button>
</div>

<div class="cards-wrap mt-5">
  <div *ngFor="let domain of domainSummaries" class="card-item">
    <p-panel class="card-panel" [header]="'Domain ' + domain.domain">
      <ng-container *ngIf="domain.row; else noData">
        <div class="kv">
          <div class="kv-row">
            <div class="kv-label">Customer</div>
            <div class="kv-value">{{ domain.row.CUSTOMER || '—' }}</div>
          </div>
          <div class="kv-row">
            <div class="kv-label">Trunks (channels)</div>
            <div class="kv-value">{{ domain.row.TRUNKS_CHANNELS }}</div>
          </div>
          <div class="kv-row">
            <div class="kv-label">Total 911</div>
            <div class="kv-value">{{ domain.row['TOTAL 911'] }}</div>
          </div>
          <div class="kv-row">
            <div class="kv-label">Total TNs</div>
            <div class="kv-value">{{ domain.row['TOTAL TNs'] }}</div>
          </div>
          <div class="kv-row">
            <div class="kv-label">Billable 911</div>
            <div class="kv-value">{{ domain.row['BILLABLE 911'] }}</div>
          </div>
          <div class="kv-row">
            <div class="kv-label">Billable TNs</div>
            <div class="kv-value">{{ domain.row['BILLABLE TNS'] }}</div>
          </div>
          <div class="kv-row">
            <div class="kv-label">Physical Fax</div>
            <div class="kv-value">{{ domain.row['PHYSICAL FAX'] }}</div>
          </div>
          <div class="kv-row">
            <div class="kv-label">Virtual Fax</div>
            <div class="kv-value">{{ domain.row['VIRTUAL FAX'] }}</div>
          </div>
        </div>
      </ng-container>

      <ng-template #noData>
        <i>No summary returned for this domain.</i>
      </ng-template>
    </p-panel>
  </div>
</div>
</div>
}
